import { useOrgAuthMethods } from 'api/AuthenticationPolicyAPI';
import { fetchUserProjectRequest, selectEmail } from 'core/userContext';
import { authMethodsText } from 'modules/authenticationPolicy/utils';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AVATAR_SIZES, Avatar } from 'ui/avatar';
import { BUTTON_SIZES } from 'ui/button';
import { Divider } from 'ui/divider';
import { SecondaryPageHeader } from 'ui/pageHeader';
import { Body2, H4, Subtitle2 } from 'ui/theme';
import { fetchUserPreferencesRequest, resetPasswordRequest } from '../actions';
import { USER_PREFERENCES_PAGE_TEXT as TEXT } from '../constants';
import { selectUserPreferences } from '../selectors';
import { fullName, headerText } from '../utils';
import { EditDetailsForm } from './EditDetailsForm';
import {
  ActionButton,
  FullName,
  LeftDiv,
  ProfileContent,
  RightDiv,
  Section,
  SecurityContent,
} from './Styled';

export const UserPreferencesPage = () => {
  const dispatch = useDispatch();
  const email = useSelector(selectEmail) as string | undefined;
  const {
    data: { googleAuthEnabled, samlAuthEnabled, userPassAuthEnabled } = {},
  } = useOrgAuthMethods();

  const { details } = useSelector(selectUserPreferences);
  const { firstName, lastName, avatarUrl } = details;

  const [isEditingDetails, setIsEditingDetails] = useState(false);

  useEffect(() => {
    dispatch(fetchUserProjectRequest());
    dispatch(fetchUserPreferencesRequest());
  }, [dispatch]);

  const onClickReset = () => {
    dispatch(resetPasswordRequest({ email }));
  };

  return (
    <div>
      <SecondaryPageHeader>{headerText(email)}</SecondaryPageHeader>
      <Section>
        <LeftDiv>
          <H4>{TEXT.PROFILE.TITLE}</H4>
          <Body2>{TEXT.PROFILE.DESCRIPTION}</Body2>
        </LeftDiv>
        <RightDiv>
          {isEditingDetails ? (
            <EditDetailsForm
              initFirstName={firstName}
              initLastName={lastName}
              avatarUrl={avatarUrl}
              onCancel={() => {
                setIsEditingDetails(false);
              }}
            ></EditDetailsForm>
          ) : (
            <ProfileContent>
              <Avatar
                firstName={firstName}
                lastName={lastName}
                imgSrc={avatarUrl}
                size={AVATAR_SIZES.MEDIUM}
              />
              <div>
                <FullName>{fullName(firstName, lastName)}</FullName>
                <Body2>{email}</Body2>
              </div>
              <ActionButton size={BUTTON_SIZES.LARGE} onClick={() => setIsEditingDetails(true)}>
                {TEXT.EDIT_BUTTON}
              </ActionButton>
            </ProfileContent>
          )}
        </RightDiv>
      </Section>
      <Divider />
      <Section>
        <LeftDiv>
          <H4>{TEXT.SECURITY.TITLE}</H4>
          <Body2>{TEXT.SECURITY.DESCRIPTION}</Body2>
        </LeftDiv>
        <RightDiv>
          <SecurityContent>
            <div>
              <Subtitle2>{TEXT.SECURITY.AUTH_METHOD}</Subtitle2>
              <Body2>
                {authMethodsText({ googleAuthEnabled, samlAuthEnabled, userPassAuthEnabled })}
              </Body2>
            </div>
            <ActionButton onClick={onClickReset}>
              {TEXT.SECURITY.RESET_PASSWORD_BUTTON}
            </ActionButton>
          </SecurityContent>
        </RightDiv>
      </Section>
    </div>
  );
};
